import styled from 'styled-components';

export const QuickStartErrorStyled = styled.div`
  
  h3 {
      font-weight: bold;
      text-align: end;
      font-size: 1.3rem;
      transform: translateY(-.5rem);
      margin-bottom: 1rem;
    }

  >p {
    font-size: 1.4rem;
  }

  >button {
    margin: 0 auto;
    margin-top: 1rem;
  }
`